import React from "react";
import { formatFullWeekdayShortDate } from "../../../../../../../common/utils/date";
import { useNutritionPlan } from "../../store/useNutritionPlan";
import PlanSidePanel from "../../../shared/PlanSidePanel";
import DayIntakePanel from "./DayIntakePanel";

/** The full intake breakdown (the mobile DayIntake screen) in the right drawer. */
const IntakeSidePanel = () => {
  const { intake, closeIntake, getDay } = useNutritionPlan();
  const day = intake ? getDay(intake.date) : undefined;

  return (
    <PlanSidePanel
      open={!!intake}
      onClose={closeIntake}
      title={intake ? `${formatFullWeekdayShortDate(intake.date)} — Intake` : "Intake"}
    >
      {intake && day && (
        <DayIntakePanel
          key={`${intake.date}-${intake.initialMealType}`}
          day={day}
          initialMealType={intake.initialMealType}
        />
      )}
    </PlanSidePanel>
  );
};

export default IntakeSidePanel;
